var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blockquote',{staticClass:"quote"},[_c('div',{staticClass:"quote__content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.autop(_vm.content))}})]),_c('footer',[_c('cite',{staticClass:"quote__author"},[_vm._v(" "+_vm._s(_vm.author)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }